import React, { createContext} from "react";

  const AuthUser = React.createContext();
  export default AuthUser;